// 自动导入各包模块图标
// prettier-ignore
const modules = {};

try {
  const req = require.context('./', true, /all\-source\.js$/)

  req.keys().forEach((key) => {
    if (key !== './index.js') {
      const parts = key.split('/')
      if (parts.length > 2) {
        modules[parts[1]] = req(key).default
      }
    }
  })
} catch (e) {
  console.warn('require.context not available, using manual import method')
}

export default modules
